exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".face-value-ledger-note {\n  padding: 8px 12px;\n  margin-bottom: 15px;\n  font-size: 14px; }\n  .face-value-ledger-note .glyphicon-info-sign {\n    margin-right: 4px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/denomination/edit/denomination.edit.scss
// module id = 1144
// module chunks = 1